import { BMCard, BMPrimitives, BMText } from "@traveloka/district-bloom";
import IcSystemLocationBloom from "@traveloka/icon-kit-web/react/IcSystemLocationBloom";
import { Image, Pressable, StyleSheet } from "react-native";
import BMView from "../../../components/View/BMView";
import { useHotelAutocomplete } from "../../../providers/api/HotelAutocompleteContext";
import { RecentSearchHotelPropertyItem } from "../../../providers/api/RecentlyViewedHotelsContext";
import { convert, formatCurrency } from "../../../utils";

type Props = RecentSearchHotelPropertyItem;

export default function HotelCard(props: Props) {
  const { price, hotelName, location, image, hotelId } = props;
  const { handleSelectSearchItem } = useHotelAutocomplete();
  return (
    <Pressable
      onPress={() =>
        handleSelectSearchItem({
          id: hotelId,
          name: hotelName,
          type: "HOTEL",
        })
      }
    >
      <BMCard style={styles.card} layout="COMPACT" elevation="FLOAT">
        <BMView flex row spacing="md">
          <Image
            source={{
              uri: image,
            }}
            style={styles.image}
          />
          <BMView flex spacing="xs">
            <BMText ink="BMStyleTextInkPrimary" variant="uiLarge">
              {hotelName}
            </BMText>
            <BMView row spacing="xs" align="center">
              {location && (
                <>
                  <IcSystemLocationBloom width={16} height={16} />
                  <BMText ink="BMStyleTextInkSecondary" variant="uiNormalLi">
                    {location}
                  </BMText>
                </>
              )}
            </BMView>
            <BMText
              style={styles.price}
              variant="uiNormalEm"
              ink="BMStyleTextInkPrice"
            >
              {Number(price.amount) > 0 ? formatCurrency(convert(price)) : null}
            </BMText>
          </BMView>
        </BMView>
      </BMCard>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  card: {
    width: 266,
    height: 114,
  },
  image: {
    marginVertical: -BMPrimitives.BMSize.md,
    marginLeft: -BMPrimitives.BMSize.md,
    width: 72,
    height: 112,
    objectFit: "cover",
  },
  price: {
    marginTop: BMPrimitives.BMSize.xs,
  },
});
